import styled from "styled-components";
import { BRAND } from "@streeteasy/design-system/colors";

import { largeScreen } from "src/shared/constants/screenSizes";

import HeaderNavButton from "../../HeaderNavButton";

export const SignInRegisterButton = styled(HeaderNavButton)`
  && {
    line-height: normal;
    @media screen and (max-width: ${largeScreen}px) {
      color: ${BRAND};
      padding: 0px;
      margin: 12px 0;
      font-weight: bold;
      font-size: 14px;
      text-align: left;
      line-height: 22px;
    }

    &:hover,
    &:active,
    &:focus {
      @media screen and (max-width: ${largeScreen}px) {
        color: ${BRAND};
        text-decoration: none;
      }
    }
  }
`;
